import { render, staticRenderFns } from "./Resendforverification.vue?vue&type=template&id=1b5bb175&"
import script from "./Resendforverification.vue?vue&type=script&lang=js&"
export * from "./Resendforverification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b5bb175')) {
      api.createRecord('1b5bb175', component.options)
    } else {
      api.reload('1b5bb175', component.options)
    }
    module.hot.accept("./Resendforverification.vue?vue&type=template&id=1b5bb175&", function () {
      api.rerender('1b5bb175', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/auth/Resendforverification.vue"
export default component.exports